export class Brand {
   brandid: number;
    brandname: string;
    active: number;
}